/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail', {
            parent: 'board.dinghy.event',
            url: '/detail/{id}',
            views: {
                'content@': {
                    templateUrl: 'app/board/dinghy/event/detail/dinghyEventNavbar.html',
                    controller: 'DinghyEventNavController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'DinghyEventBoard', function($stateParams, DinghyEventBoard) {
                    return DinghyEventBoard.get({id : $stateParams.id}).$promise;
                }]
            }
        });
    }
})();
